class MobileMenu {
  constructor() {
    this.mobileMenuBtn = document.getElementById('mobile-menu-btn')
    this.mobileMenu = document.getElementById('mobile-menu')
    this.mobileMenuClose = document.getElementById('mobile-menu-close')
    this.burgerIcon = document.getElementById('burger-icon')
    this.closeIcon = document.getElementById('close-icon')

    this.init()
  }

  init() {
    if (!this.mobileMenu) return

    this.attachEventListeners()
    this.attachSubmenuHandlers()
  }

  attachEventListeners() {
    if (this.mobileMenuBtn) {
      this.mobileMenuBtn.addEventListener('click', () => {
        if (this.mobileMenu.classList.contains('active')) {
          this.close()
        } else {
          this.open()
        }
      })
    }

    if (this.mobileMenuClose) {
      this.mobileMenuClose.addEventListener('click', () => this.close())
    }

    this.mobileMenu.addEventListener('click', (e) => {
      if (e.target === this.mobileMenu) {
        this.close()
      }
    })
  }

  attachSubmenuHandlers() {
    const menuItems = document.querySelectorAll('.mobile-menu-item')

    menuItems.forEach((item) => {
      item.addEventListener('click', () => {
        const submenu = item.nextElementSibling
        const chevron = item.querySelector('.mobile-chevron')

        if (submenu && submenu.classList.contains('mobile-submenu')) {
          const isOpen = submenu.style.display === 'block'

          document.querySelectorAll('.mobile-submenu').forEach((sub) => {
            sub.style.display = 'none'
          })

          document.querySelectorAll('.mobile-chevron').forEach((chev) => {
            chev.style.transform = 'rotate(0deg)'
          })

          if (!isOpen) {
            submenu.style.display = 'block'
            chevron.style.transform = 'rotate(180deg)'
          }
        }
      })
    })
  }

  open() {
    this.mobileMenu.style.display = 'block'
    document.body.classList.add('menu-open')

    setTimeout(() => {
      this.mobileMenu.classList.add('active')
    }, 10)

    if (this.burgerIcon) this.burgerIcon.style.display = 'none'
    if (this.closeIcon) this.closeIcon.style.display = 'block'
  }

  close() {
    this.mobileMenu.classList.remove('active')

    setTimeout(() => {
      this.mobileMenu.style.display = 'none'
      document.body.classList.remove('menu-open')
    }, 300)

    if (this.burgerIcon) this.burgerIcon.style.display = 'block'
    if (this.closeIcon) this.closeIcon.style.display = 'none'
  }

  static open() {
    const instance = window.mobileMenuInstance
    if (instance) {
      instance.open()
    }
  }

  static close() {
    const instance = window.mobileMenuInstance
    if (instance) {
      instance.close()
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.mobileMenuInstance = new MobileMenu()
})
